import { useState, useContext } from 'react';
import {UserContext} from '../contexts';

const emptyMessage = {
    buttonText: null,
    hideMessageButtonText: null,
    content: null,
    id: null,
    isActive: false,
    lang: 'he',
    workspace: 'ofek',
    lastUpdatedDate: null,
    lastUpdatedUser: null,
    link: null,
    linkTarget: "",
    popupContent: null,
    scheduleFrom: null,
    scheduleTo: null,
    showButton: false,
    showHideMessageButton: false,
    title: null,
    type: '',
    userType: 'everyone'
};

export const useSystemMessages = () => {
    const [user] = useContext(UserContext);

    const [isMessageLoading, setIsMessageLoading] = useState(false);
    const [errorMessageLoading, setErrorMessageLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const getMessage = (type, lang, workspace) => {
        setIsMessageLoading(true);
        setErrorMessageLoading(false);

        window.cet.microservices.nairobiapi.systemMessages.getMessagesByType({
            language: lang,
            workspace: workspace,
            type: type
        }).then(data => {
            let message1 = data.length > 0 ? {
                ...(data[0]),
                workspace: workspace,
                lastUpdatedDate: data[0].lastUpdatedDate ? new Date(data[0].lastUpdatedDate) : null,
                scheduleFrom: data[0].scheduleFrom ? new Date(data[0].scheduleFrom) : null,
                scheduleTo: data[0].scheduleTo ? new Date(data[0].scheduleTo) : null,
                userType: data[0].userType || 'everyone'
            } : {
                ...emptyMessage,
                lang: lang,
                workspace: workspace,
                type: type,
            };
            setMessage(message1);
            setIsMessageLoading(false);
            setErrorMessageLoading(false);
        }).catch(error => {
            setIsMessageLoading(false);
            setErrorMessageLoading(error);
            setMessage(null);
        });
    };

    const updateMessage = (message) => {
        var fetch = window.cet.microservices.nairobiapi.systemMessages.setMessage({
            ...message, 
            workspace: message.workspace,
            lastUpdatedUser: user && user.displayName ? user.displayName : '', 
            lastUpdatedDate: new Date()
        });
        fetch.then(data => {
            let message1 = data ? {
                ...(data),
                workspace: message.workspace,
                lastUpdatedDate: data.lastUpdatedDate ? new Date(data.lastUpdatedDate) : null,
                scheduleFrom: data.scheduleFrom ? new Date(data.scheduleFrom) : null,
                scheduleTo: data.scheduleTo ? new Date(data.scheduleTo) : null,
            } : null;
            setMessage(message1);
        });
        return fetch;
    };

    const clearErrorMessageLoading = () => {
        setErrorMessageLoading(false);
    };

    return {
        isMessageLoading: isMessageLoading,
        errorMessageLoading: errorMessageLoading,
        message: message,
        clearErrorMessageLoading: clearErrorMessageLoading,
        getMessage: getMessage,
        updateMessage: updateMessage
    };
}